// @ts-ignore
import { getField, updateField } from 'vuex-map-fields'
import BusinessAccountAPI from '@/API/ordering/business-account-api'

export default {
  namespaced: true,
  state: {
    vendorBranchId: null,
    vendor: null,
    vendors: [],
    vendorsFetched: false,
    readonly: false,
    superAdmin: false,
  },
  getters: {
    getField,
    vendor: (state: any) => state.vendor,
    vendors: (state: any) => state.vendors,
    currentBranchId: (state: any) => state.vendorBranchId,
    readonly: (state: any) => state.readonly,
    superAdmin: (state: any) => state.superAdmin,
  },
  mutations: {
    updateField,
    SET_VENDOR(state: any, vendor: any) {
      state.vendor = vendor
    },
    SET_VENDORS(state: any, vendors: any) {
      state.vendors = vendors
    },
    SET_VENDOR_BRANCH(state: any, branchId: number) {
      state.vendorBranchId = branchId
    },
    SET_VENDOR_READONLY(state: any, readonly: boolean) {
      state.readonly = readonly
    },
    SET_VENDOR_SUPERADMIN(state: any, superAdmin: boolean) {
      state.superAdmin = superAdmin
    },
  },
  actions: {
    async GET_VENDOR({ commit, rootGetters }: any, {
      customBranchId, readonly, superAdmin, vendorId, vendorSlug,
    }: any = {}) {
      const branchId = customBranchId || rootGetters['branches/currentBranchId']
      commit('SET_VENDOR_BRANCH', branchId)
      commit('SET_VENDOR_READONLY', readonly ?? false)
      commit('SET_VENDOR_SUPERADMIN', superAdmin ?? false)
      const vendor = await BusinessAccountAPI.getAccountDetailsByVendorId(vendorId || undefined, vendorSlug || undefined, customBranchId)
      commit('SET_VENDOR', vendor)
      return vendor
    },
    async GET_VENDORS(context: any, slug: any) {
      const vendors = await BusinessAccountAPI.getVendors(slug)
      context.commit('SET_VENDORS', vendors)
      return vendors
    },

    async PROCESS_VENDOR(context: any, form: any) {
      const data = await BusinessAccountAPI.handleCustomTokenVendor(form)
      const vendor = data.data
      const vendorIdx = context.state.vendors.findIndex((b: any) => b.id === vendor.id)
      const vendors = [...context.state.vendors]
      if (vendorIdx >= 0) {
        vendors[vendorIdx] = {
          ...vendors[vendorIdx],
          ...vendor,
        }
      } else {
        vendors.push(vendor)
      }
      context.commit('SET_VENDORS', vendors)
      return data
    },
  },
}
